UADeleteLicensesCtrl.$inject = [
  '$state',
  'importState',
  'adminApi',
  '$uibModalInstance',
  'users',
  'domainUuid'
]
export default function UADeleteLicensesCtrl(
  $state,
  importState,
  adminApi,
  $modalInstance,
  users,
  domainUuid
) {
  // for now we just create an import record with preset users, and redirect to 4th step in the wizard
  this.loading = false
  this.showError = false
  this.errorMessage = ''
  this.users = users
  var userUuids = users.map(function(u) {
    return u.uuid
  })

  this.createImport = function() {
    this.loading = true
    adminApi.deleteLicensesForUsers(userUuids, domainUuid).then(
      function(response) {
        if (response.import_uuid) {
          this.importUuid = response.import_uuid
          $modalInstance.close(response)
          $state.go('import-wizard.import-status', {
            domainUuid: domainUuid,
            importUuid: response.import_uuid
          })
        } else {
          this.showError = true
          this.errorMessage = response
        }
        this.loading = false
      }.bind(this),
      function(response) {
        this.showError = true
        this.errorMessage = response
        this.loading = false
      }.bind(this)
    )
  }
}
